export default __webpack_public_path__ + "static/media/kueper.32c6ebe2.jpg";